import { forwardRef, LegacyRef } from 'react';

const SimpleTextInput = forwardRef(function SimpleTextInput(
	{
		disabled,
		placeholder,
		className = '',
		...props
	}: React.InputHTMLAttributes<HTMLInputElement>,
	ref: LegacyRef<HTMLInputElement>
) {
	return (
		<input
			placeholder={placeholder ? placeholder : 'Input'}
			className={`h-11 w-full rounded-lg border-0 bg-black/30 px-3 text-sm text-foreground shadow-inset-well placeholder:text-muted-foreground focus:outline-none focus:ring-0 disabled:opacity-50 ${className}`}
			ref={ref}
			{...props}
		/>
	);
});

export default SimpleTextInput;
